export function createUniqueTag(): string {
  const tag = Math.random()
    .toString()
    .substring(2)
    + Math.random()
      .toString()
      .substring(2)
      + Math.random()
        .toString()
        .substring(2)
        + Math.random()
          .toString()
          .substring(2);
  return tag;
}

export async function hashPassword(toHash: string, salt: string = "axure") {
  const msgToHash = `${salt}${toHash}`;

  if (crypto && crypto.subtle && crypto.subtle.digest) {
    const msgUint8 = new TextEncoder().encode(msgToHash); // encode as (utf-8) Uint8Array
    const hashBuffer = await crypto.subtle.digest("SHA-512", msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join(""); // convert bytes to hex string
    return hashHex;
  }

  const { default: { sha512 } } = await import("sha.js");
  // eslint-disable-next-line new-cap
  return new sha512().update(msgToHash).digest("hex");
}

/* eslint-disable no-bitwise */
export function simpleHash(toHash: string): number {
  let hash = 0;
  if (toHash.length === 0) {
    return hash;
  }
  for (let i = 0; i < toHash.length; i++) {
    const char = toHash.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash &= hash;
  }
  return hash;
}
/* eslint-enable no-bitwise */

export function combineQueryWithHash(query: { [key: string]: any }, hash: string) {
  const queryParams = { ...query };
  const vars = hash.substring(1).split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    queryParams[pair[0]] = pair[1];
  }
  return queryParams;
}
